import * as React from 'react';

export const mustheadText = `
We believe every pet deserves a peaceful end-of-life experience. 
That's why 100% of donations to the Angel Fund support families in need of our services. 
Would you like to help a family and their pet?
`;

export const angelFundFiftyTitle = (
	<>
		<span className="highlight">Dedicated</span> to pets and their families
	</>
);

export const angelBlockRichTitle = (
	<>
		Your donation makes a lasting <span className="highlight">impact</span>
	</>
);

export const angelFundFiftyText = `
Lap of Love is dedicated to walking pets and families through the delicate final moments of a pet’s life, 
allowing for the human-animal bond to remain as undisturbed as possible. But the reality is, many pet parents 
can’t afford our services. That's why we set up the Lap of Love Angel Fund, which is dedicated to ensuring as 
many in-need families as possible get to experience a most beautiful and compassionate end-of-life experience 
with their pet from the comfort of their homes. Would you like to donate to the fund and become an angel today? 
`;
